import React from 'react';

const Exclusive = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="10" cy="10" r="10" fill="white" />
      <circle cx="10" cy="10" r="10" fill="url(#paint0_linear_4246_22398)" />
      <circle cx="10" cy="10" r="9.5" stroke="white" stroke-opacity="0.3" />
      <g filter="url(#filter0_f_4246_22398)">
        <path
          d="M13.9985 14.8639C13.8486 15.2475 13.4789 15.5 13.067 15.5L6.93296 15.5C6.5211 15.5 6.15136 15.2475 6.0015 14.8638L4.38435 10.7239C4.2308 10.3308 4.60327 9.93606 5.00463 10.0665L7.31407 10.8171C7.53548 10.889 7.77725 10.7987 7.89717 10.5991L9.57144 7.81313C9.76571 7.48987 10.2343 7.48987 10.4286 7.81313L12.3077 10.94L14.9954 10.0665C15.3967 9.93606 15.7692 10.3308 15.6156 10.7239L13.9985 14.8639Z"
          fill="url(#paint1_linear_4246_22398)"
          fill-opacity="0.8"
        />
      </g>
      <path
        d="M14.2989 13.8349C14.1572 14.2337 13.7798 14.5 13.3567 14.5L6.64333 14.5C6.22017 14.5 5.84282 14.2337 5.70109 13.8349L3.85287 8.63554C3.71168 8.23834 4.09517 7.85542 4.49216 7.9972L7.09798 8.92785C7.32953 9.01055 7.58685 8.91261 7.70483 8.69688L9.56132 5.30217C9.75097 4.95538 10.249 4.95538 10.4387 5.30217L12.5 9.07143L15.5078 7.9972C15.9048 7.85542 16.2883 8.23834 16.1471 8.63554L14.2989 13.8349Z"
        fill="url(#paint2_linear_4246_22398)"
      />
      <mask id="mask0_4246_22398" maskUnits="userSpaceOnUse" x="3" y="5" width="14" height="10">
        <path
          d="M14.2989 13.8349C14.1572 14.2337 13.7798 14.5 13.3567 14.5L6.64333 14.5C6.22017 14.5 5.84282 14.2337 5.70109 13.8349L3.85287 8.63554C3.71168 8.23834 4.09517 7.85542 4.49216 7.9972L7.09798 8.92785C7.32953 9.01055 7.58685 8.91261 7.70483 8.69688L9.56132 5.30217C9.75097 4.95538 10.249 4.95538 10.4387 5.30217L12.5 9.07143L15.5078 7.9972C15.9048 7.85542 16.2883 8.23834 16.1471 8.63554L14.2989 13.8349Z"
          fill="#4F5FEE"
        />
      </mask>
      <g mask="url(#mask0_4246_22398)">
        <path
          d="M7.69553 15.3355L12.9897 4.63044L14.3047 5.6651L9.0106 16.3701L7.69553 15.3355Z"
          fill="url(#paint3_linear_4246_22398)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4246_22398"
          x="0.348633"
          y="3.57031"
          width="19.3027"
          height="15.9297"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_4246_22398" />
        </filter>
        <linearGradient
          id="paint0_linear_4246_22398"
          x1="2"
          y1="2.5"
          x2="18.1029"
          y2="17.3887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5353" />
          <stop offset="0.614583" stop-color="#6D38FB" />
          <stop offset="1" stop-color="#009DFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4246_22398"
          x1="16"
          y1="10.818"
          x2="3.99991"
          y2="10.796"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5353" />
          <stop offset="0.614583" stop-color="#6D38FB" />
          <stop offset="1" stop-color="#009DFF" />
        </linearGradient>
        <linearGradient id="paint2_linear_4246_22398" x1="15" y1="14.5" x2="7.5" y2="7" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" stop-opacity="0.2" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4246_22398"
          x1="14.0002"
          y1="7.00024"
          x2="7.79941"
          y2="15.4463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.4" />
          <stop offset="0.778573" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Exclusive;
